import type { SVGProps } from 'react';
const SvgAssistantNavigation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#assistant_navigation_svg__a)">
      <path
        fill="currentColor"
        d="M12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1Zm3.57 16L12 15.42 8.43 17l-.37-.37L12 7l3.95 9.63-.38.37Z"
      />
    </g>
    <defs>
      <clipPath id="assistant_navigation_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAssistantNavigation;
